import { useContext, useEffect, useState } from "react";

import DialogCustom from "components/DesignComponents/DialogCustom";
import TableContext from "context/table/tableContext";

import { MobileDetailsProps } from "./types";

const MobileDetails = ({ children }: MobileDetailsProps) => {
    const { detailsData, setDetailsData } = useContext(TableContext);

    const [isOpen, setIsOpen] = useState(Boolean(detailsData));

    useEffect(() => {
        detailsData ? setIsOpen(true) : setIsOpen(false);
    }, [detailsData]);

    return detailsData ? (
        <DialogCustom
            fullWidth
            open={isOpen}
            close={() => setDetailsData(null)}
            transitionDuration={0}
            customPadding="16px 24px"
        >
            {children}
        </DialogCustom>
    ) : (
        <div></div>
    );
};

export default MobileDetails;
